(function() {
  const sliders = document.querySelectorAll('.custom-slider-section .custom-slider');
  
  sliders.forEach((slider) => {
    const track = slider.querySelector('.custom-slider__track');
    const cells = slider.querySelectorAll('.custom-slider__cell');
    const prevButton = slider.querySelector('.custom-slider__arrow--prev');
    const nextButton = slider.querySelector('.custom-slider__arrow--next');
    let currentIndex = 0;
    const totalCells = cells.length;
    const cellsPerView = 3;

    function updateSlider() {
      const offset = currentIndex * (100 / cellsPerView);
      track.style.transform = `translateX(-${offset}%)`;
      prevButton.disabled = false;
      nextButton.disabled = false;
    }

    prevButton.addEventListener('click', () => {
      currentIndex--;
      if (currentIndex < 0) {
        currentIndex = Math.max(0, totalCells - cellsPerView);
      }
      updateSlider();
    });

    nextButton.addEventListener('click', () => {
      currentIndex++;
      if (currentIndex >= totalCells - cellsPerView + 1 && totalCells >= cellsPerView) {
        currentIndex = 0;
      }
      updateSlider();
    });

    // Handle edge case for fewer than 3 images
    if (totalCells < cellsPerView) {
      currentIndex = 0;
      prevButton.disabled = true;
      nextButton.disabled = true;
    }

    updateSlider();
  });

  // Popup functionality (shared across all sliders)
  const popup = document.querySelector('.custom-popup');
  const popupImage = popup.querySelector('.custom-popup__image');
  const popupPrev = popup.querySelector('.custom-popup__arrow--prev');
  const popupNext = popup.querySelector('.custom-popup__arrow--next');
  const popupClose = popup.querySelector('.custom-popup__close');
  let popupIndex = 0;
  let activeCells = [];

  function updatePopupButtons() {
    popupPrev.disabled = false;
    popupNext.disabled = false;
  }

  function openPopup(index, cells) {
    activeCells = cells;
    popupIndex = index;
    popupImage.src = activeCells[popupIndex].querySelector('img').dataset.full;
    popupImage.alt = activeCells[popupIndex].querySelector('img').alt;
    popup.style.display = 'flex';
    updatePopupButtons();
  }

  document.querySelectorAll('.custom-slider-section .custom-slider').forEach((slider) => {
    const cells = Array.from(slider.querySelectorAll('.custom-slider__cell'));
    cells.forEach((cell, index) => {
      cell.querySelector('img').addEventListener('click', () => openPopup(index, cells));
    });
  });

  popupPrev.addEventListener('click', () => {
    popupIndex = (popupIndex - 1 + activeCells.length) % activeCells.length;
    popupImage.src = activeCells[popupIndex].querySelector('img').dataset.full;
    popupImage.alt = activeCells[popupIndex].querySelector('img').alt;
    updatePopupButtons();
  });

  popupNext.addEventListener('click', () => {
    popupIndex = (popupIndex + 1) % activeCells.length;
    popupImage.src = activeCells[popupIndex].querySelector('img').dataset.full;
    popupImage.alt = activeCells[popupIndex].querySelector('img').alt;
    updatePopupButtons();
  });

  popupClose.addEventListener('click', () => {
    popup.style.display = 'none';
  });

  popup.addEventListener('click', (e) => {
    if (e.target === popup) {
      popup.style.display = 'none';
    }
  });

  document.addEventListener('keydown', (e) => {
    if (popup.style.display === 'flex') {
      if (e.key === 'ArrowLeft') {
        popupIndex = (popupIndex - 1 + activeCells.length) % activeCells.length;
        popupImage.src = activeCells[popupIndex].querySelector('img').dataset.full;
        popupImage.alt = activeCells[popupIndex].querySelector('img').alt;
        updatePopupButtons();
      } else if (e.key === 'ArrowRight') {
        popupIndex = (popupIndex + 1) % activeCells.length;
        popupImage.src = activeCells[popupIndex].querySelector('img').dataset.full;
        popupImage.alt = activeCells[popupIndex].querySelector('img').alt;
        updatePopupButtons();
      } else if (e.key === 'Escape') {
        popup.style.display = 'none';
      }
    }
  });
})();
